import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import Expanded from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_maximise.svg';
import Collapsed from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_minimise.svg';

import { Root } from './styled';

const ResizeIcon = props => {
  const { isCollapsed, onClickCallback } = props;

  const icon = isCollapsed ? Expanded : Collapsed;

  return (
    <Root data-testid="footer-resize-icon" isCollapsed={isCollapsed} onClick={() => onClickCallback(!isCollapsed)}>
      <Isvg src={icon} cacheRequests />
    </Root>
  );
};

ResizeIcon.propTypes = {
  isCollapsed: PropTypes.bool.isRequired,
  onClickCallback: PropTypes.func.isRequired
};

export default ResizeIcon;



// WEBPACK FOOTER //
// ./components/footer/resize-icon/index.js